import type { StyleDictionary } from 'pdfmake/interfaces';

/**
 * Centralized style definitions for pdfmake PDF generation
 * These styles match the current HTML/CSS design
 */
export const pdfStyles: StyleDictionary = {
  // Section title (e.g., "MAIN CASE INFORMATION")
  sectionTitle: {
    fontSize: 12,
    bold: true,
    fillColor: '#E7EAEC',
    margin: [0, 1, 0, 1] as [number, number, number, number],
    color: '#000',
  },

  // Card header (light gray background)
  cardHeader: {
    fillColor: '#f9f9f9',
    margin: [0, 0, 0, 3] as [number, number, number, number],
    fontSize: 10,
  },

  // Field label (bold)
  fieldLabel: {
    bold: true,
    fontSize: 10,
    color: '#000',
  },

  // Field value (normal)
  fieldValue: {
    fontSize: 10,
    color: '#000',
  },

  // Mention value in narrative print (without leading @)
  mentionValue: {
    fontSize: 10,
    color: '#000',
    bold: true,
  },

  // Redacted content (solid black)
  redacted: {
    fillColor: 'black',
    color: 'black',
    fontSize: 10,
  },

  // Table header
  tableHeader: {
    bold: true,
    fontSize: 10,
    fillColor: '#f9f9f9',
    color: '#000',
  },

  // Table cell
  tableCell: {
    fontSize: 9,
    color: '#000',
  },

  // Header styles
  headerAgencyName: {
    fontSize: 14,
    bold: true,
    color: '#000',
  },

  headerDetails: {
    fontSize: 11,
    color: '#000',
  },

  headerCaseInfo: {
    fontSize: 10,
    bold: true,
    color: '#000',
  },

  headerTimestamp: {
    fontSize: 11,
    color: '#000',
  },

  // Footer
  footer: {
    fontSize: 9,
    color: '#000',
  },
};

/**
 * Page margins configuration
 */
export const pageMargins: [number, number, number, number] = [20, 155, 20, 30]; // left, top, right, bottom

/**
 * Default table layout with black borders
 */
export const defaultTableLayout = {
  hLineWidth: () => 1,
  vLineWidth: () => 1,
  hLineColor: () => '#000',
  vLineColor: () => '#000',
  paddingLeft: () => 4,
  paddingRight: () => 4,
  paddingTop: () => 2,
  paddingBottom: () => 2,
  fillColor: (rowIndex: number) => {
    return rowIndex === 0 ? '#f9f9f9' : null;
  },
};

/**
 * Light table layout (no vertical lines between columns)
 */
export const lightTableLayout = {
  hLineWidth: (i: number, node: any) =>
    i === 0 || i === node.table.body.length ? 1 : 1,
  vLineWidth: () => 0,
  hLineColor: () => '#000',
  paddingLeft: () => 4,
  paddingRight: () => 4,
  paddingTop: () => 2,
  paddingBottom: () => 2,
};

/**
 * Card border style
 */
export const cardBorder = {
  hLineWidth: () => 1,
  vLineWidth: () => 1,
  hLineColor: () => '#000',
  vLineColor: () => '#000',
};
